import React, { createContext, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetSelectedProjectMutation } from "../redux/slices/projectApiSlice";
import { setSelectedProject } from "../redux/slices/projectSlice";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [project, setProject] = useState(null);
  const [getSelectedProject, { isLoading }] = useGetSelectedProjectMutation();
  // Export modal functions
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("default");
  const [blogPost, setBlogPost] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await getSelectedProject().unwrap();
        const sanitizedData = Object.fromEntries(
          Object.entries(res?.data || {}).map(([key, value]) => [
            key,
            value === null ? "" : value,
          ])
        );
        setProject(sanitizedData);
        dispatch(setSelectedProject(sanitizedData));
      } catch (error) {
        // console.log(error);
      }
    };

    fetchProject();
  }, []);

  return (
    <ProjectContext.Provider
      value={{
        project,
        isLoading,
        open,
        setOpen,
        modalType,
        setModalType,
        blogPost,
        setBlogPost,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

// Custom hook for accessing Project context context
export const useProject = () => useContext(ProjectContext);
